export default __webpack_public_path__ + "assets/hotgiggity-live-marker.d995589e.png";